(function () {
  var originalTitle = document.title;
  var messages = ["🔥 ¡Vuelve!", "📩 No olvides esto..."];
  var timer = null;
  var index = 0;

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    document.title = originalTitle;
  }

  function start() {
    originalTitle = originalTitle || document.title;
    if (timer) return;
    document.title = messages[0];
    index = 1;
    timer = window.setInterval(function () {
      document.title = messages[index % messages.length];
      index += 1;
    }, 1000);
  }

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) start();
    else stop();
  });

  window.addEventListener("focus", stop);
  window.addEventListener("blur", function () {
    if (document.hidden) start();
  });
})();
